import { Http } from '@visiba/http';
import { Singleton } from '@visiba/instantiation';
import { HttpService } from './http.service';

/** This service's only purpose is to fetch svg images and return the data */
@Singleton()
export class SvgHttpService {
	private readonly http = Http.create('visiba-image-http-client');

	constructor() {
		// Empty
	}

	public get(...args: ArgumentTypes<HttpService['http']['get']>): Promise<string> {
		return this.http.get<string>(...args).then(({ data }) => data);
	}
}
